export const SidebarData = [
    {
        title: 'Салатлар / Салаты',
        cName: 'sidebar-text',
        link: '#salads'
    },
    {
        title: 'Биринчи Таомлар / первые блюда',
        cName: 'sidebar-text',
        link: '#soups'
    },
    {
        title: 'Иккинчи Таомлар / Вторые блюда',
        cName: 'sidebar-text',
        link: '#meals'
    },
    {
        title: 'Мангал',
        cName: 'sidebar-text',
        link: '#mangal'
    },
    {
        title: 'Aссорти',
        cName: 'sidebar-text',
        link: '#assorti'
    },
    {
        title: 'Десертлар / Десерты',
        cName: 'sidebar-text',
        link: '#sweets'
    },
    {
        title: 'Чойлар / Чаи',
        cName: 'sidebar-text',
        link: '#tea'
    },
    {
        title: 'Кофе',
        cName: 'sidebar-text',
        link: '#coffee'
    },
    {
        title: 'Лимонадлар / Лимонады',
        cName: 'sidebar-text',
        link: '#ichimliklar'
    },
    {
        title: 'фреш',
        cName: 'sidebar-text',
        link: '#fresh'
    },
    {
        title: 'Смузи',
        cName: 'sidebar-text',
        link: '#smooth'
    },
    {
        title: 'Милк Шейк',
        cName: 'sidebar-text',
        link: '#sheyk'
    },
]
